import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Segment, Dropdown, Header } from 'semantic-ui-react';
import { getIdentityManagers, deleteIdentityManager } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { yesNo } from '../../utils/defaults';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
import { NotificationManager } from 'react-notifications';

const initialState = {
    template: "",
    clientId: "",
    secretCode: "",
    active: ""
}

class IdentityManager extends Component {

    constructor(props) {
        super(props);
        this.state = {
          loading: true,
          deleteIdentityModal: false,
          identityManagers: [],
          templateId: 0,
          searchIndex: initialState
        }
      }

    componentDidMount() {
        this.props.addItem("helpFile", "admin_users.md");
        this.loadIdentityManager();
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    loadIdentityManager = () => {
        this.setState((prevState, props) => {
            return { loading: true }
        }, () => {
            getIdentityManagers(this.state.searchIndex).then(response => {
                if (response !== null) {
                    this.setState((prevState, props) => {
                        return { identityManagers: response, loading: false }
                    })
                }
            }).then((error) => {
                this.setState({ loading: false })
            });
        });
    }
    deleteIdentityManager = () => {
        deleteIdentityManager(this.state.templateId).then(response => {
            NotificationManager.success('Success', 'Deleted successfully.');
          this.setState((prevState, props) => {
            return {
                identityManagers: this.state.identityManagers.filter((u) => {
                return u.limId !== this.state.templateId;
              }), deleteIdentityModal: false, templateId: 0
            }
          })
        })
      }

      openDeleteModal = (id) => {
        this.setState((prevState, props) => {
          return { deleteIdentityModal: true, templateId: id }
        });
      }

      close = () => {
        this.setState((prevState, props) => {
          return { deleteIdentityModal: false }
        })
      }

      resetSearch = () => {
        this.setState((prevState, props) => {
          return {
            searchIndex: initialState
          }
        }, () => this.loadIdentityManager())
      }

      handleChange = (e, data) => {
        this.setState({
          searchIndex: {
            ...this.state.searchIndex,
            [data.name]: data.value
          }
        });
      }

      render() {
        if (this.state.loading) {
          return (
            <Loading />
          )
        }
        const { identityManagers } = this.state;
        return (
          <div>
            <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "IdentityManager", url: null }]} />
            <Grid className="g-bkgd">
              <Grid.Row>
                <Grid.Column>
                  <Form className="small">
                    <Form.Group widths='equal'>
                      <Form.Field width={4}>
                        <label>Template:</label>
                        <Form.Input placeholder='Template' onChange={this.handleChange} value={this.state.searchIndex.template} name="template" />
                      </Form.Field>
                      <Form.Field width={4}>
                        <label>Client Id:</label>
                        <Form.Input placeholder='Client Id' onChange={this.handleChange} value={this.state.searchIndex.clientId} name="clientId" />
                      </Form.Field>
                      <Form.Field width={3}>
                        <label>Secret Code:</label>
                        <Form.Input placeholder='Secret Code' onChange={this.handleChange} value={this.state.searchIndex.secretCode} name="secretCode" />
                      </Form.Field>
                      <Form.Field width={3}>
                        <label>Active Status:</label>
                        <Dropdown placeholder='Active Status' className="fluid" selection options={yesNo} value={this.state.searchIndex.active} onChange={this.handleChange} name="active"></Dropdown>
                      </Form.Field>
                      <Form.Field width={2}>
                        <Button.Group className="small push-down">
                          <Button onClick={this.resetSearch}>{this.props.t("reset")}</Button>
                          <Button.Or />
                          <Button positive onClick={this.loadIdentityManager}>{this.props.t("submit")}</Button>
                        </Button.Group>
                      </Form.Field>
                    </Form.Group>
                  </Form>
                  <Segment.Group raised>
                    <Segment.Group horizontal>
                      <Segment color="grey" inverted>
                        <Header as="h4">
                          <Icon name="users" />
                          <div className="content">
                            Identity Manager
                           </div>
                        </Header>
                      </Segment>
                      <Segment color="grey" inverted>
                        <Button as={Link} to={"/identity/0"} className="inverted right floated small">
                          Add a template
                          </Button>
                      </Segment>
                    </Segment.Group>
                    <ReactTable minRows={0} filterable defaultPageSize={this.props.reactTable().pageSize} showPagination={identityManagers.length > this.props.reactTable().identityManagers ? true : false} defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                      data={identityManagers}
                      getNoDataProps={() => {
                        return { style: { display: 'none' } };
                      }}
                      columns={[{
                        Header: props => <span data-inverted="" data-tooltip="Template Name" data-position="bottom left">Template Name</span>,
                        accessor: 'limTemplateName' 
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="The User FirstName" data-position="bottom left">Client Id</span>,
                        accessor: 'limClientId',
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="The User LastName" data-position="bottom left">Secret Code</span>,
                        accessor: 'limClientSecret',
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Is template is deactivated?" data-position="bottom right">Active Status</span>,
                        id: 'limActive',
                        width: 90,
                        style: {
                          textAlign: "center"
                        },
                        filterable: false,
                        accessor: row => (
                          row.limActive === 'Y' ? "Yes" : "No"
                        )
                      }, {
                        Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                        filterable: false,
                        width: 130,
                        style: {
                          textAlign: "center"
                        },
                        Cell: row => (
                          <div>
                            <Button as={Link} to={"/identity/" + row.original.limId} className="icon mini" data-tooltip="Edit template" data-inverted="" data-position="top right" ><Icon name="pencil alternate" /></Button>
                            <Button onClick={() => this.openDeleteModal(row.original.limId)} className="icon mini" data-inverted="" data-tooltip="Delete template" data-position="top right"><Icon name="trash alternate outline" /></Button>
                          </div>
                        )
                      }]}
                    />
                  </Segment.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <MessageBox {...this.props} box={12} size="tiny" open={this.state.deleteIdentityModal} close={this.close} contentTitle="Delete template?" content="Are you sure you want to delete this template?" yesHandle={this.deleteIdentityManager} />
          </div>
        );
      }
    }

    export default IdentityManager;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/IdentityManager.js